import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleCall = () => {
    window.location.href = 'tel:0650088282';
  };

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => navigate('/')}>
            <img 
              src="https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/we4jswbw_IMG_9185.png" 
              alt="SolinoPro Logo"
              className="h-14 w-auto object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => navigate('/')}
              className={`font-medium transition-colors ${
                isActive('/') ? 'text-[#8B7355]' : 'text-gray-700 hover:text-[#8B7355]'
              }`}
            >
              Accueil
            </button>
            <button 
              onClick={() => navigate('/services')}
              className={`font-medium transition-colors ${
                isActive('/services') ? 'text-[#8B7355]' : 'text-gray-700 hover:text-[#8B7355]'
              }`}
            >
              Services
            </button>
            <button 
              onClick={() => navigate('/catalogue')}
              className={`font-medium transition-colors ${
                isActive('/catalogue') ? 'text-[#8B7355]' : 'text-gray-700 hover:text-[#8B7355]'
              }`}
            >
              Catalogue
            </button>
            <button 
              onClick={() => navigate('/realisations')}
              className={`font-medium transition-colors ${
                isActive('/realisations') ? 'text-[#8B7355]' : 'text-gray-700 hover:text-[#8B7355]'
              }`}
            >
              Réalisations
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button 
              onClick={handleCall}
              className="bg-[#8B7355] hover:bg-[#6B5744] text-white px-6 py-2 rounded-lg font-medium transition-all duration-300 hover:shadow-lg flex items-center space-x-2"
            >
              <Phone className="w-4 h-4" />
              <span>06 50 08 82 82</span>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-gray-900"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 py-4 space-y-3">
            <button 
              onClick={() => { navigate('/'); setIsMobileMenuOpen(false); }}
              className={`block w-full text-left px-4 py-2 transition-colors ${
                isActive('/') ? 'bg-[#F5EFE6] text-[#8B7355]' : 'text-gray-700 hover:bg-[#F5EFE6] hover:text-[#8B7355]'
              }`}
            >
              Accueil
            </button>
            <button 
              onClick={() => { navigate('/services'); setIsMobileMenuOpen(false); }}
              className={`block w-full text-left px-4 py-2 transition-colors ${
                isActive('/services') ? 'bg-[#F5EFE6] text-[#8B7355]' : 'text-gray-700 hover:bg-[#F5EFE6] hover:text-[#8B7355]'
              }`}
            >
              Services
            </button>
            <button 
              onClick={() => { navigate('/catalogue'); setIsMobileMenuOpen(false); }}
              className={`block w-full text-left px-4 py-2 transition-colors ${
                isActive('/catalogue') ? 'bg-[#F5EFE6] text-[#8B7355]' : 'text-gray-700 hover:bg-[#F5EFE6] hover:text-[#8B7355]'
              }`}
            >
              Catalogue
            </button>
            <button 
              onClick={() => { navigate('/realisations'); setIsMobileMenuOpen(false); }}
              className={`block w-full text-left px-4 py-2 transition-colors ${
                isActive('/realisations') ? 'bg-[#F5EFE6] text-[#8B7355]' : 'text-gray-700 hover:bg-[#F5EFE6] hover:text-[#8B7355]'
              }`}
            >
              Réalisations
            </button>
            <div className="px-4 pt-2">
              <Button 
                onClick={handleCall}
                className="w-full bg-[#8B7355] hover:bg-[#6B5744] text-white py-3 rounded-lg font-medium flex items-center justify-center space-x-2"
              >
                <Phone className="w-4 h-4" />
                <span>06 50 08 82 82</span>
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
